import React, { useEffect, useState } from "react";
import { BsHouse } from "react-icons/bs";
import styles from "./Navbar.module.css";
import { Link, useNavigate } from "react-router-dom";
import { FiLogOut, FiMenu, FiUser, FiUserPlus } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { logout, setLanguage } from "../../redux/features/authSlice";
import { Button, Dropdown, message, Switch, Tooltip } from "antd";
import avatar from "../../assets/userAvatar.png";
import { FaAngleDown } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdClose, MdOutlineDashboard, MdOutlineDraw } from "react-icons/md";
import logoImg from "../../assets/logo.png";
import logoLightImg from "../../assets/logoLight.png";
import { getTranslation } from "../../util/utilFunc";
import { UserOutlined } from "@ant-design/icons";

function Navbar({ textTheme }) {
  const { userInfo, language } = useSelector((state) => state.auth);

  const { first_name, last_name } = userInfo || {};
  const [isToggle, setIsToggle] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    message.success(getTranslation("Logged out successfully!", language));
  };

  const handleChangeLang = (isArabic) => {
    // console.log(isArabic);
    const language = isArabic ? "ar" : "en";
    dispatch(setLanguage(language));
  };

  const itemsProfile = [
    {
      key: "1",
      icon: <MdOutlineDashboard style={{ fontSize: "1.2rem" }} />,
      label: (
        <Link
          onClick={() => localStorage.setItem("selectedKey", "1")}
          to={getDashboardUrl()}
        >
          {getTranslation("My Dashboard", language)}
        </Link>
      ),
    },
    {
      key: "2",
      icon: <UserOutlined style={{ fontSize: "1.2rem" }} />,
      label: (
        <Link to={getProfileUrl()}>
          {getTranslation("My Profile", language)}
        </Link>
      ),
    },
    {
      key: "3",
      icon: (
        <MdOutlineDraw
          style={{ fontSize: "1.2rem" }}
          className={styles.nav_icon}
        />
      ),
      label: (
        <Link to={"/dashboard/my-drawings"}>{getTranslation("My Drawing", language)}</Link>
      ),
    },

    {
      key: "4",
      danger: true,
      icon: <FiLogOut style={{ fontSize: "1.2rem" }} />,
      label: (
        <div onClick={handleLogout}>{getTranslation("Logout", language)}</div>
      ),
    },
  ];

  function getDashboardUrl() {
    let url = "/dashboard";
    if (userInfo?.usertype === "superadmin") {
      url = "/superadmin/dashboard";
    }

    return url;
  }

  function getProfileUrl() {
    let url = "/dashboard/my-profile";
    if (userInfo?.usertype === "superadmin") {
      url = "/superadmin/dashboard/my-profile";
    }

    return url;
  }

  return (
    <nav
      className={`${styles.navbar} ${scrolled || isMobile ? styles.scrolledNav : ""
        }
    ${textTheme ? styles.lightText : ""} `}
    >
      <div className={styles.logo__wrapper}>
        <div className={styles.logo__item}>
          <img src={scrolled || isMobile ? logoImg : logoLightImg} alt="." />
          <h3>Compelion</h3>
        </div>
        {isToggle ? (
          <MdClose
            onClick={() => setIsToggle(false)}
            className={`${styles.toggler} ${styles.toggleIconClose}`}
          />
        ) : (
          <FiMenu
            onClick={() => setIsToggle(true)}
            className={`${styles.toggler} ${styles.toggleIconClose}`}
          />
        )}
      </div>
      <ul
        className={`${styles.navbar__links} ${isToggle ? styles.toggled__navList : ""
          }`}
      >
        {isToggle && (
          <li
            style={{ textAlign: "right", margin: "10px 0px" }}
            className={styles.notification__wrapper}
          >
            <Tooltip
              title={language === "ar" ? "Change Language?" : "تغيير اللغة"}
            >
              <Switch
                checked={language === "ar"}
                onChange={handleChangeLang}
                checkedChildren="English"
                unCheckedChildren="عربي"
              />
            </Tooltip>
          </li>
        )}

        <li>
          <Link to="/">
            <BsHouse className={styles.nav_icon} />
            <span>{getTranslation("Home", language)}</span>
          </Link>
        </li>
        <li>
          <Link to="/about-us">
            <FiUser className={styles.nav_icon} />
            <span>{getTranslation("About", language)}</span>
          </Link>
        </li>
        <li>
          <Link to="/contact-us">
            <FaPhoneAlt className={styles.nav_icon} />
            <span>{getTranslation("Contact", language)}</span>
          </Link>
        </li>
        {userInfo && isToggle && (
          <>
            <li>
              <Link to={getDashboardUrl()}>
                <MdOutlineDashboard
                  style={{ fontSize: "1.2rem" }}
                  className={styles.nav_icon}
                />
                <span>{getTranslation("My Dashboard", language)}</span>
              </Link>
            </li>
            <li>
              <Link to={getProfileUrl()}>
                <UserOutlined
                  style={{ fontSize: "1.2rem" }}
                  className={styles.nav_icon}
                />
                <span> {getTranslation("My Profile", language)}</span>
              </Link>
            </li>
            <li>
              <Link to={"/dashboard/my-drawings"}>
                <MdOutlineDraw
                  style={{ fontSize: "1.2rem" }}
                  className={styles.nav_icon}
                />
                <span>{getTranslation("Drawing", language)}</span>
              </Link>
            </li>

            <li>
              <Button
                style={{ margin: "10px", width: "100%" }}
                danger
                onClick={handleLogout}
              >
                <FiLogOut className={styles.nav_icon} />
                <span>{getTranslation("Logout", language)}</span>
              </Button>
            </li>
          </>
        )}
      </ul>
      <ul>
        {!isToggle && !isMobile && (
          <li className={styles.notification__wrapper}>
            <Tooltip
              title={language === "ar" ? "Change Language?" : "تغيير اللغة"}
            >
              <Switch
                checked={language === "ar"}
                onChange={handleChangeLang}
                checkedChildren="English"
                unCheckedChildren="عربي"
              />
            </Tooltip>
          </li>
        )}

        {userInfo ? (
          !isToggle &&
          !isMobile && (
            <>

              <div>
                <Dropdown
                  menu={{
                    items: itemsProfile,
                  }}
                >
                  <div className={styles.profile__wrapper}>
                    <img src={avatar} alt="." />
                    <span>
                      {first_name} {last_name}
                    </span>
                    <FaAngleDown />
                  </div>
                </Dropdown>
              </div>
            </>
          )
        ) : (
          <li className={styles.btn__wrapper}>
            <Link className="primaryBtn" to="/login">
              <FiUserPlus className={styles.nav_icon} />
              {getTranslation("Login", language)}
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
